import { roundCurrency } from 'utils/currency';

const CLOUD_FUNCTIONS_BASE =
  'https://us-central1-clube-42-3baa5.cloudfunctions.net';

export interface ShippingQuoteResponse {
  price: number;
  deliveryTime: number;
  deliveryTimeLabel: string;
  carrier: string;
  service: string;
  serviceId: number;
}

export interface ShippingQuoteRequest {
  destinationPostalCode: string;
  destinationCity?: string;
  destinationUf?: string;
  bottleCount: number;
  insuranceValue: number;
}

export const getMelhorEnvioQuote = async (
  params: ShippingQuoteRequest,
): Promise<ShippingQuoteResponse> => {
  const response = await fetch(
    `${CLOUD_FUNCTIONS_BASE}/getMelhorEnvioQuote`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(params),
    },
  );

  const result = (await response.json()) as
    | ShippingQuoteResponse
    | { error?: string };

  if (!response.ok) {
    throw new Error(
      'error' in result && result.error
        ? result.error
        : 'Erro ao calcular frete',
    );
  }

  const quote = result as ShippingQuoteResponse;

  return {
    ...quote,
    price: roundCurrency(quote.price),
  };
};
